import {
  JbRichtext
} from "./chunk.ILHQLCTW.js";
import {
  JbButtonSwitch
} from "./chunk.BNMOG2GQ.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  JBCookie
} from "./chunk.SYAPDNOX.js";
import {
  __decorateClass
} from "./chunk.7VONTVYH.js";

// src/components/jb-cookie-settings/jb-cookie-settings.ts
import { html, LitElement, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";

// src/components/jb-cookie-settings/jb-cookie-settings.scss?inline
import { css } from "lit-element/lit-element.js";
var jb_cookie_settings_default = css`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* stylelint-disable */
/* stylelint-enable */
h4 {
  font-family: VerlagSSm, Tahoma, sans-serif;
  font-weight: 400;
}

h2 {
  font-family: VerlagSSm, Tahoma, sans-serif;
  font-style: normal;
  font-weight: 300;
}

h2 {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 21px;
  line-height: 34px;
}
@media (min-width: 1281px) {
  h2 {
    font-size: 24px;
    line-height: 36px;
  }
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
}

section {
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  justify-content: center;
}

.container {
  box-sizing: border-box;
  flex-basis: 100%;
  max-width: 100%;
  padding: 0 0;
  width: 100%;
  background-color: var(--background-color, #141e55);
  padding: 60px 20px;
  position: relative;
}
@media (min-width: 960px) {
  .container {
    padding: 70px 98px;
  }
}

h2 {
  box-sizing: border-box;
  flex-basis: 100%;
  max-width: 100%;
  padding: 0 0;
  width: 100%;
  color: #fff;
  margin-bottom: 10px;
}

slot[name=introduction]::slotted(jb-richtext) {
  color: rgba(255, 255, 255, 0.8);
  --rgb-primary: 255, 255, 255;
  --text-opacity: 1;
}

.options {
  margin-bottom: 30px;
  padding-top: 30px;
}
@media (min-width: 1281px) {
  .options {
    column-gap: 40px;
    columns: 2;
  }
}

slot[name=options]::slotted(jb-button-switch) {
  break-inside: avoid;
  color: rgba(255, 255, 255, 0.7);
  display: block;
  margin-bottom: 30px;
  --rgb-primary: 255, 255, 255;
  --text-opacity: 1;
}

.additional-text {
  break-inside: avoid;
  margin-top: -10px;
}

h4 {
  font-size: 16px;
  font-size: 1rem;
  line-height: 26px;
  line-height: 1.625rem;
  color: #fff;
  margin-bottom: 10px;
}

slot[name=additionalText]::slotted(jb-richtext) {
  color: RGBA(255, 255, 255, 0.7);
  --rgb-primary: 255, 255, 255;
  --text-opacity: 1;
}

jb-button-panel {
  padding-bottom: 5px;
  --rgb-primary: 255, 255, 255;
}

jb-close-icon {
  position: absolute;
  right: 22px;
  top: 20px;
  --rgb-primary: 255, 255, 255;
  --icon-size: 26px;
}
@media (min-width: 960px) {
  jb-close-icon {
    right: 45px;
    top: 40px;
    --icon-size: 30px;
  }
}

jb-button,
jb-button-primary,
jb-button-secondary,
jb-button-tertiary {
  width: 100%;
}
@media (min-width: 960px) {
  jb-button,
  jb-button-primary,
  jb-button-secondary,
  jb-button-tertiary {
    margin-bottom: 0;
    width: auto;
  }
}`;

// src/components/jb-cookie-settings/jb-cookie-settings.ts
var JbCookieSettings = class extends Initiable(LitElement) {
  constructor() {
    super(...arguments);
    this._newCookieSettings = /* @__PURE__ */ new Map();
  }
  static create(data) {
    const childNodes = [];
    childNodes.push(
      new JbRichtext().init({
        innerHTML: data.introduction.content,
        props: { ...data.introduction, size: "small" },
        attributes: { slot: "introduction" }
      })
    );
    childNodes.push(
      ...data.options.map(
        (option) => new JbButtonSwitch().init({
          props: option,
          attributes: { slot: "options" }
        })
      )
    );
    if (data.additionalText) {
      childNodes.push(
        new JbRichtext().init({
          innerHTML: data.additionalText.content,
          props: { ...data.additionalText, size: "mini" },
          attributes: { slot: "additionalText" }
        })
      );
    }
    return new JbCookieSettings().init({ props: data, childNodes });
  }
  acceptAll() {
    this.addEventListener("button-switch:initialized", (event) => {
      this._forceSetting(event, true);
      this._save();
    });
    document.body.append(this);
    this.parentElement?.removeChild(this);
  }
  setConsentFor(optionNames) {
    this.addEventListener("button-switch:initialized", (event) => {
      const buttonSwitch = event.detail.buttonSwitch;
      if (!buttonSwitch.name) {
        return;
      }
      if (optionNames.includes(buttonSwitch.name)) {
        this._forceSetting(event, true);
      }
    });
    document.querySelector("body")?.append(this);
    this.parentElement?.removeChild(this);
    window.setTimeout(() => {
      this._save();
    }, 0);
  }
  _buttonClicked(e) {
    e.stopPropagation();
    e.detail.clickEvent.preventDefault();
    if (e.detail.name === "save") {
      this._save();
      JBCookie.setCookie("hide_cookie_banner", "1");
      JBCookie.setCookie("show_cookie_banner", "0");
      JBCookie.setCookie("cookie_banner_suppressed", "0");
      this.dispatchEvent(new CustomEvent("jb-popup:close-stack", { bubbles: true, composed: true }));
    } else {
      this.dispatchEvent(new CustomEvent("jb-popup:close", { bubbles: true, composed: true }));
    }
  }
  _forceSetting(e, state) {
    const { name } = e.detail.buttonSwitch;
    e.detail.buttonSwitch.setState(state);
    this._newCookieSettings.set(name, state);
  }
  _handleCloseIconClick() {
    this.dispatchEvent(new CustomEvent("jb-popup:close", { bubbles: true, composed: true }));
  }
  static _initializeSetting(e) {
    const { name } = e.detail.buttonSwitch;
    const value = JBCookie.getCookie(name);
    if (value) {
      e.detail.buttonSwitch.setState(true);
    }
  }
  _save() {
    this._newCookieSettings.forEach((value, key) => {
      if (value) {
        JBCookie.setCookie(key, "1");
      } else {
        JBCookie.deleteCookie(key);
      }
    });
    document.body.dispatchEvent(
      new CustomEvent("jb-cookie-settings:update", {
        bubbles: true,
        composed: true,
        detail: { updatedCookieSettings: this._newCookieSettings }
      })
    );
    this._newCookieSettings = /* @__PURE__ */ new Map();
  }
  _settingChanged(e) {
    e.stopPropagation();
    this._newCookieSettings.set(e.detail.name, e.detail.checked);
  }
  render() {
    return html`
      <section>
        <div class="container">
          <jb-close-icon @click=${this._handleCloseIconClick}></jb-close-icon>
          <h2>${this.headline}</h2>
          <slot name="introduction"></slot>
          <div class="options">
            <slot
              name="options"
              @button-switch:initialized=${JbCookieSettings._initializeSetting}
              @button-switch:changed=${this._settingChanged}
            ></slot>
            <div class="additional-text">
              ${this.additionalHeadline ? html`<h4>${this.additionalHeadline}</h4>` : nothing}
              <slot name="additionalText"></slot>
            </div>
          </div>
          <jb-button-panel @jb-button:clicked=${this._buttonClicked}>
            <jb-button-secondary
              inverted
              .name=${"cancel"}
            >
              ${this.cancelButtonText}
            </jb-button-secondary>
            <jb-button-primary
              inverted
              .name=${"save"}
            >
              ${this.saveButtonText}
            </jb-button-primary>
          </jb-button-panel>
        </div>
      </section>
    `;
  }
};
JbCookieSettings.styles = unsafeCSS(jb_cookie_settings_default);
__decorateClass([
  property()
], JbCookieSettings.prototype, "additionalHeadline", 2);
__decorateClass([
  property()
], JbCookieSettings.prototype, "cancelButtonText", 2);
__decorateClass([
  property()
], JbCookieSettings.prototype, "headline", 2);
__decorateClass([
  property()
], JbCookieSettings.prototype, "saveButtonText", 2);
JbCookieSettings = __decorateClass([
  customElement("jb-cookie-settings")
], JbCookieSettings);

export {
  JbCookieSettings
};
